/**
 * @description: 曲库管理
 * @author: hwx
 */
<template>
	<div class="qzg">
		<div class="qzg-list" v-show="showList">
			<h1 class="title">曲库资料管理</h1>
			<div class="row row-margin">
				<label class="ct-label">评分:</label>
				<div class="col-md-2 ct-col">
					<select class="select2" ref="qzgGrade" data-placeholder="请选择评分">
						<option value="0">全部</option>
						<option value="1">有</option>
						<option value="-1">无</option>
					</select>
				</div>
				<label class="ct-label">画质:</label>
				<div class="col-md-2 ct-col">
					<select class="select2" ref="qzgImgQt" data-placeholder="请选择画质">
						<option value="0">全部</option>
						<option value="1">差</option>
						<option value="2">标清</option>
						<option value="3">高清</option>
						<option value="-1">未知</option>
					</select>
				</div>
				<label class="ct-label">伴奏音质:</label>
				<div class="col-md-2 ct-col">
					<select class="select2" ref="qzgAccQt" data-placeholder="请选择伴奏音质">
						<option value="0">全部</option>
						<option value="1">消音版</option>
						<option value="2">原版</option>
						<option value="-1">未知</option>
					</select>
				</div>
				<div class="col-md-1 ct-col" style="width: 116px; padding: 0;">
					<select class="form-control" ref="query_sel">
						<option value="1">歌曲名称</option>
						<option value="2">歌手</option>
					</select>
				</div>
				<div class="col-md-2 pdmg">
					<input type="text" class="form-control" v-model="query_val" :placeholder="query_phd">
				</div>
			</div>
			<div class="row">
				<div class="pull-right">
					<button type="button" class="btn btn-flat btn-small btn-orange" @click="clkEdit">新增歌曲</button>
				</div>
				<div class="pull-right">
					<button type="button" class="btn btn-flat btn-small btn-orange" @click="clkImport" style="margin: 0 20px;">导入</button>
				</div>
				<div class="pull-right">
					<button type="button" class="btn btn-flat btn-small btn-orange" @click="clkQuery">查询</button>
				</div>
			</div>
			<div class="table-responsive">
				<table class="table table-striped table-bordered table-hover" data-pagination="true" ref="qzgList"></table>
			</div>
		</div>
		<div class="qzg-import" v-show="showImport">
			<div class="clearfix">
				<h1>歌曲导入格式模板</h1>
				<div class="pull-right">
					<button type="button" class="btn btn-flat btn-small btn-orange" @click="addXlsFun">直接导入</button>
					<input type="file" @change="uploadMusicFile($event)" ref="musicXlsFile" id="musicXlsFile">
				</div>
				<a href="https://vodonline.oss-cn-beijing.aliyuncs.com/ktv/uploads/%E5%B7%A8%E5%97%A8%E6%9B%B2%E5%BA%93%E6%A8%A1%E6%9D%BF.xls" class="btn btn-flat btn-small btn-orange pull-right">模板下载</a>
				<button type="button" class="btn btn-flat btn-small btn-orange pull-right" @click="backList">返回</button>
			</div>
			<p>注：在云库上传成功后的歌曲，方能成功导入<br />如果是单个歌星的比如刘德华，歌星：刘德华。歌星1：刘德华<br />如果是合唱的比如刘德华 梅艳芳，歌星：刘德华 梅艳芳。歌星1：刘德华。歌星2：梅艳芳</p>
			<table>
				<thead>
					<th>歌曲编号</th>
					<th>歌曲名称</th>
					<th>歌曲文件名</th>
					<th>歌手</th>
					<th>歌手1</th>
					<th>歌手2</th>
					<th>画质</th>
					<th>伴奏音质</th>
					<th>语言</th>
					<th>分类</th>
					<th>日语检索码</th>
				</thead>
				<tbody>
					<tr>
						<td>123456</td>
						<td>彩虹</td>
						<th>彩虹.mkv</th>
						<td>周杰伦</td>
						<td>可不填写</td>
						<td>可不填写</td>
						<td>高清</td>
						<td>原版</td>
						<td>国语</td>
						<td>情歌对唱</td>
						<td>可不填写</td>
					</tr>
					<tr>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
					</tr>
					<tr>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
					</tr>
					<tr>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
					</tr>
					<tr>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
					</tr>
					<tr>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
					</tr>
					<tr>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
					</tr>
					<tr>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
					</tr>
					<tr>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
					</tr>
					<tr>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
					</tr>
					<tr>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
					</tr>
					<tr>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="qzg-edit" v-show="showEdit">
			<div class="page_header">{{page_header}}</div>
			<div class="edit-base clearfix">
				<h4>基本资料</h4>
				<div class="row rowpadding">
					<label class="col-md-1 ctr-label-left">歌曲编号:</label>
					<div class="col-md-4">
						<input class="form-control" placeholder="请输入歌曲编号" v-model="szSong_code">
					</div>
				</div>
				<div class="row rowpadding">
					<label class="col-md-1 ctr-label-left">歌曲名称:</label>
					<div class="col-md-4">
						<input class="form-control" placeholder="请输入歌曲名称" v-model="szSong_name">
					</div>
				</div>
				<div class="row rowpadding">
					<label class="col-md-1 ctr-label-left">歌曲文件名:</label>
					<div class="col-md-4">
						<input class="form-control" placeholder="请输入歌曲文件名" v-model="file_name">
					</div>
				</div>
				<div class="row rowpadding">
					<label class="col-md-1 ctr-label-left">歌名长度:</label>
					<div class="col-md-4">
						<input class="form-control" placeholder="请输入歌名长度" v-model="nNameLen">
					</div>
				</div>
				<div class="row rowpadding">
					<label class="col-md-1 ctr-label-left">歌手:</label>
					<div class="col-md-4">
						<input class="form-control" placeholder="请输入歌手" v-model="szPlayer">
					</div>
					<span class="rmarkspan" titles="如果是单个歌手的比如刘德华，歌手：刘德华。歌手1：刘德华</br> 如果是合唱的比如刘德华 梅艳芳，歌手：刘德华 梅艳芳。歌手1：刘德华。歌手2：梅艳芳" @mouseenter="hint_language($event)" @mouseleave="close_hint_language"></span>
				</div>
				<div class="row rowpadding">
					<label class="col-md-1 ctr-label-left">歌手1:</label>
					<div class="col-md-4">
						<input class="form-control" placeholder="请输入歌手1" v-model="szPlayer1">
					</div>
				</div>
				<div class="row rowpadding">
					<label class="col-md-1 ctr-label-left">歌手2:</label>
					<div class="col-md-4">
						<input class="form-control" placeholder="请输入歌手2" v-model="szPlayer2">
					</div>
				</div>
				<div class="row rowpadding">
					<label class="col-md-1 ctr-label-left">歌曲版本:</label>
					<div class="col-md-4 ct-col">
						<select class="form-control" ref="songs_version" data-placeholder="请选择歌曲版本">
							<option value="1">原人原唱</option>
							<option value="2">演唱会</option>
							<option value="3">影视</option>
							<option value="4">翻唱</option>
							<option value="5">高清</option>
						</select>
					</div>
				</div>
				<div class="row rowpadding">
					<label class="col-md-1 ctr-label-left">评分:</label>
					<div class="col-md-4 ct-col">
						<select class="form-control" ref="nPingFen" data-placeholder="是否有评分">
							<option value="1">有</option>
							<option value="-1">无</option>
						</select>
					</div>
				</div>
				<div class="row rowpadding">
					<label class="col-md-1 ctr-label-left">画质:</label>
					<div class="col-md-4 ct-col">
						<select class="form-control" ref="frame_quality" data-placeholder="请选择画质">
							<option value="1">差</option>
							<option value="2">标清</option>
							<option value="3">高清</option>
							<option value="-1">未知</option>
						</select>
					</div>
				</div>
				<div class="row rowpadding">
					<label class="col-md-1 ctr-label-left">伴奏音质:</label>
					<div class="col-md-4 ct-col">
						<select class="form-control" ref="acc_quality" data-placeholder="请选择伴奏音质">
							<option value="1">消音版</option>
							<option value="2">原版</option>
							<option value="-1">未知</option>
						</select>
					</div>
				</div>
				<div class="row rowpadding">
					<label class="col-md-1 ctr-label-left">歌曲时长:</label>
					<div class="col-md-4">
						<input class="form-control" placeholder="请输入歌曲时长" v-model="songs_length">
					</div>
				</div>
				<div class="row rowpadding">
					<label class="col-md-1 ctr-label-left">前奏时长:</label>
					<div class="col-md-4">
						<input class="form-control" placeholder="请输入歌曲前奏时长" v-model="prelude_length">
					</div>
				</div>
			</div>
			<div class="edit-other">
				<h4>其他资料</h4>
				<div class="row rowpadding">
					<label class="col-md-1 ctr-label-left">首拼码1:</label>
					<div class="col-md-4">
						<input class="form-control" placeholder="请输入首拼码1" v-model="szNamePy1">
					</div>
				</div>
				<div class="row rowpadding">
					<label class="col-md-1 ctr-label-left">首拼码2:</label>
					<div class="col-md-4">
						<input class="form-control" placeholder="请输入首拼码2" v-model="szNamePy2">
					</div>
				</div>
				<div class="row rowpadding">
					<label class="col-md-1 ctr-label-left">全拼码1:</label>
					<div class="col-md-4">
						<input class="form-control" placeholder="请输入全拼码1" v-model="szNameAllPy1">
					</div>
				</div>
				<div class="row rowpadding">
					<label class="col-md-1 ctr-label-left">全拼码2:</label>
					<div class="col-md-4">
						<input class="form-control" placeholder="请输入全拼码2" v-model="szNameAllPy2">
					</div>
				</div>
				<div class="row rowpadding">
					<label class="col-md-1 ctr-label-left">unicode编码:</label>
					<div class="col-md-4">
						<input class="form-control" placeholder="请输入unicode编码" v-model="szUnicode">
					</div>
				</div>
				<div class="row rowpadding">
					<label class="col-md-1 ctr-label-left">日语检索码:</label>
					<div class="col-md-4">
						<input class="form-control" placeholder="请输入日语检索码" v-model="szJapanesePy">
					</div>
				</div>
				<div class="row rowpadding">
					<label class="col-md-1 ctr-label-left">封面视频戳1:</label>
					<div class="col-md-4">
						<img class="qzg-dfimg1" :src="cover_url1" @click="addCoverFun(1)">
						<input type="file" class="qzg-uploadinp" id="coverFile1" ref="coverFile1" @change="uploadCover($event, 1)">
					</div>
				</div>
				<div class="row rowpadding">
					<label class="col-md-1 ctr-label-left">封面视频戳2:</label>
					<div class="col-md-4">
						<img class="qzg-dfimg2" :src="cover_url2" @click="addCoverFun(2)">
						<input type="file" class="qzg-uploadinp" id="coverFile2" ref="coverFile2" @change="uploadCover($event, 2)">
					</div>
				</div>
				<div class="row rowpadding">
					<label class="col-md-1 ctr-label-left">语言：</label>
					<div class="col-md-4">
						<input class="form-control input-readonly" placeholder="请选择语言" v-model="language_txt" ref="language_txt" readonly="readonly" @click="goSelLanguage($event)">
						<span :class="objClass" @click="clearLanguage">×</span>
						<span class="printer_arrow" role="presentation"><b role="presentation"></b></span>
					</div>
				</div>
				<div class="row rowpadding">
					<label class="col-md-1 ctr-label-left">分类：</label>
					<div class="col-md-4">
						<input class="form-control input-readonly" placeholder="请选择分类" v-model="type_txt" ref="type_txt" readonly="readonly" @click="goSelType($event)">
						<span :class="objClass" @click="clearType">×</span>
						<span class="printer_arrow" role="presentation"><b role="presentation"></b></span>
					</div>
				</div>
			</div>
			<div class="row edit-btn">
                <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backList">返回</button>
                <button type="button" class="btn btn-flat btn-middle btn-orange" @click="qzgSub(modify)">确定</button>
            </div>
		</div>
		<div class="qzg-language" v-show="showlanguage">
			<div class="page_header">请选择语言</div>
			<ul class="clearfix">
				<li v-for="item in languageDatas">
					<input type="radio" v-model="szLanguage" :value="item.id">
					<span>{{item.name}}</span>
				</li>
			</ul>
			<div class="row">
				<button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="lgBackEdit()">返回</button>
				<button type="button" class="btn btn-flat btn-middle btn-orange"style="margin-left: 40px;" @click="lgSelFun()">确定</button>
			</div>
		</div>
		<div class="qzg-type" v-show="showType">
			<div class="page_header">请选择歌曲分类</div>
			<ul class="clearfix">
				<li v-for="item in typeDatas">
					<input type="radio" v-model="szClass" :value="item.id">
					<span>{{item.name}}</span>
				</li>
			</ul>
			<div class="row">
				<button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="typeBackEdit()">返回</button>
				<button type="button" class="btn btn-flat btn-middle btn-orange"style="margin-left: 40px;" @click="typeSelFun()">确定</button>
			</div>
		</div>
		
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		data() {
			return {
				showList: true,
				showImport: false,
				showEdit: false,
				showlanguage: false,
				showType: false,
				query_val: "",
				query_phd: "请输入歌曲名称",
				query_field: "1",
				page_header: "新增歌曲",
				szSong_code: '',
				szSong_code: '',
				szSong_name: '',
				file_name: '',
				nNameLen: '',
				szPlayer: '',
				szPlayer1: '',
				szPlayer2: '',
				songs_length: '',
				prelude_length: '',
				szNamePy1: '',
				szNamePy2: '',
				szNameAllPy1: '',
				szNameAllPy2: '',
				szUnicode: '',
				szJapanesePy: '',
				cover_url1: require('../../assets/images/upload_qzg.png'),
				cover_url2: require('../../assets/images/upload_qzg.png'),
				objClass: {
					visi_hid: false,
					selection_clear: true
				},
				language_txt: '',
				szLanguage: '',
				languageDatas: [],
				type_txt: '',
				szClass: '',
				typeDatas: [],
				modify: 1,
				theDet: {},
			}
		},
		watch: {
			language_txt: {
				handler: function(val, oldval) {
					if(val != "") {
						$(this.$refs.language_txt).parent().find('.selection_clear').show();
					} else {
						$(this.$refs.language_txt).parent().find('.selection_clear').hide();
						// this.prs_box_checkboxModel = [];
					}
				},
				deep: true
			},
			type_txt: {
				handler: function(val, oldval) {
					if(val != "") {
						$(this.$refs.type_txt).parent().find('.selection_clear').show();
					} else {
						$(this.$refs.type_txt).parent().find('.selection_clear').hide();
					}
				},
				deep: true
			}
		},
		mounted: function() {
			this.$nextTick(function() {
				let _this = this;

				$(_this.$refs.qzgGrade).select2({
					language: "zh-CN",
					allowClear: true,
					minimumResultsForSearch: -1,
					width: '100%'
				});
				$(_this.$refs.qzgImgQt).select2({
					language: "zh-CN",
					allowClear: true,
					minimumResultsForSearch: -1,
					width: '100%'
				});
				$(_this.$refs.qzgAccQt).select2({
					language: "zh-CN",
					allowClear: true,
					minimumResultsForSearch: -1,
					width: '100%'
				});
				// 下拉选项
				$(_this.$refs.query_sel).select2({
					language: "zh-CN",
					minimumResultsForSearch: -1,
					width: '100px'
				}).change(function() {
					_this.query_field = $(this).val();
					_this.query_val = '';
					if(_this.query_field == '1') {
						_this.query_phd = '请输入歌曲名称';
					} else if(_this.query_field == '2') {
						_this.query_phd = '请输入歌手名字';
					}
				});

				_this.innitTable();

				$(_this.$refs.songs_version).select2({
					allowClear: true,
					minimumResultsForSearch: -1,
					language: "zh-CN",
					width: '100%'
				});
				$(_this.$refs.nPingFen).select2({
					allowClear: true,
					minimumResultsForSearch: -1,
					language: "zh-CN",
					width: '100%'
				});
				$(_this.$refs.frame_quality).select2({
					allowClear: true,
					minimumResultsForSearch: -1,
					language: "zh-CN",
					width: '100%'
				});
				$(_this.$refs.acc_quality).select2({
					allowClear: true,
					minimumResultsForSearch: -1,
					language: "zh-CN",
					width: '100%'
				});
			});
		},
		methods: {
			// 修改页的提示语
			hint_language: function(e) {
				var contents="<span class='dots'>·</span>"+$(e.currentTarget).attr("titles");
				layer.tips(contents,$(e.currentTarget),{
					skin: 'hint_language_tip',
					tips: [2, '#fff'],
					time: 2000000,
				});
			},
			// 关闭提示语
			close_hint_language: function() {
				layer.closeAll('tips');
			},
			// 初始化曲库资料列表
			innitTable: function() {
				let _self = this;
				$(_self.$refs.qzgList).bootstrapTable({
					pageNumber: 1,
					pageSize: 10,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_self.getList(params);
					},
					sidePagination: "server",
					columns: [{
						field: "szSong_name",
						title: "歌曲名称",
						width: "10%",
						valign: "middle"
					}, {
						field: "nNameLen",
						title: "歌名长度<br>（字数/个）",
						width: "8%",
						valign: "middle"
					}, {
						field: "szPlayer",
						title: "歌手",
						width: "8%",
						valign: "middle"
					}, {
						field: "szPlayer1",
						title: "歌手1",
						width: "8%",
						valign: "middle"
					}, {
						field: "szPlayer2",
						title: "歌手2",
						width: "8%",
						valign: "middle"
					}, {
						field: "songs_version",
						title: "歌曲版本",
						width: "8%",
						valign: "middle",
						formatter: function(value, row, index) {
							if(row.songs_version == '1') {
								return '原人原唱';
							} else if(row.songs_version == '2') {
								return '演唱会';
							} else if(row.songs_version == '3') {
								return '影视';
							} else if(row.songs_version == '4') {
								return '翻唱';
							} else if(row.songs_version == '5') {
								return '高清';
							}
						}
					}, {
						field: "nPingFen",
						title: "评分",
						width: "6%",
						valign: "middle",
						formatter: function(value, row, index) {
							if(row.nPingFen == '1') {
								return '有';
							} else if(row.nPingFen == '-1') {
								return '无';
							}
						}
					}, {
						field: "frame_quality",
						title: "画质",
						width: "6%",
						valign: "middle",
						formatter: function(value, row, index) {
							if(row.frame_quality == '1') {
								return '差';
							} else if(row.frame_quality == '2') {
								return '标清';
							} else if(row.frame_quality == '3') {
								return '高清';
							} else if(row.frame_quality == '-1') {
								return '未知';
							}
						}
					}, {
						field: "acc_quality",
						title: "伴奏音质",
						width: "6%",
						valign: "middle",
						formatter: function(value, row, index) {
							if(row.acc_quality == '1') {
								return '消音版';
							} else if(row.acc_quality == '2') {
								return '原版';
							} else if(row.acc_quality == '-1') {
								return '未知';
							}
						}
					}, {
						field: "update_time",
						title: "更新时间",
						width: "8%",
						valign: "middle"
					}, {
						title: "操作",
						width: "12%",
						valign: "middle",
						events: {
							'click .edit': function(e, value, row) {
								_self.modify = 2;
								_self.getQzgDet(row.id);
								_self.showList = false;
								_self.showEdit = true;
							},
							'click .del': function(e, value, row) {
								layer.confirm('删除后不可恢复，确定删除吗？', {
									btn: ['确定', '取消']
								}, function() {
									_self.delQzg(row.id);
								});
							},
							'click .detail': function(e, value, row) {
								_self.modify = 3;
								_self.getQzgDet(row.id);
								_self.showList = false;
								_self.showEdit = true;
							}
						},
						formatter: function(value, row, index) {
							return '<span class="text-orange edit">修改</span>&nbsp;&nbsp;&nbsp;<span class="text-orange del">删除</span>&nbsp;&nbsp;&nbsp;<span class="text-orange detail">详情</span>'
						}
					}],
				});
			},
			// 表格数据
			getList: function(params) {
				let _self = this,
					pageNumber = 1;
				if(params != "" && params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"nPingFen": $(_self.$refs.qzgGrade).val(),
							"frame_quality": $(_self.$refs.qzgImgQt).val(),
							"acc_quality": $(_self.$refs.qzgAccQt).val(),
							"search_type": _self.query_field,
							"search_key": _self.query_val
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "songs/getMerchantSongsList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.total,
								rows: data.response.result.rows
							});
						} else {
							Vue.timeoutfun(data.response.result_status, _self);
							layer.msg(data.response.error_msg);
							params.success({
								total: 0,
								rows: 0
							});
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 查询
			clkQuery: function() {
				$(this.$refs.qzgList).bootstrapTable("destroy");
				this.innitTable();
			},
			// 点击跳转导入页
			clkImport: function() {
				this.showList = false;
				this.showImport = true;
			},
			// 点击跳转新增歌曲页
			clkEdit: function() {
				this.modify = 1;
				this.szSong_code = '';
				this.szSong_name = '';
				this.file_name = '';
				this.nNameLen = '';
				this.szPlayer = '';
				this.szPlayer1 = '';
				this.szPlayer2 = '';
				$(this.$refs.songs_version).val('').trigger('change');
				$(this.$refs.nPingFen).val('').trigger('change');
				$(this.$refs.frame_quality).val('').trigger('change');
				$(this.$refs.acc_quality).val('').trigger('change');
				this.songs_length = '';
				this.prelude_length = '';
				this.szNamePy1 = '';
				this.szNamePy2 = '';
				this.szNameAllPy1 = '';
				this.szNameAllPy2 = '';
				this.szUnicode = '';
				this.szJapanesePy = '';
				this.cover_url1 = require('../../assets/images/upload_qzg.png');
				$('qzg-dfimg1').removeAttr('suc');
				this.cover_url2 = require('../../assets/images/upload_qzg.png');
				$('qzg-dfimg1').removeAttr('suc');
				this.language_txt = '';
				this.szLanguage = '';
				this.type_txt = '';
				this.szClass = '';
				this.showList = false;
				this.showEdit = true;

				this.getQzgLanguage();
				this.getQzgType();
			},
			// 返回列表
			backList: function() {
				this.showList = true;
				this.showImport = false;
				this.showEdit = false;
			},
			// 点击上传xls文件
			addXlsFun: function() {
				this.$refs.musicXlsFile.click();
			},
			// 上传
			uploadMusicFile: function(e) {
				let _this = this;

				let formData = new FormData();
				formData.append("songsfile", $("#musicXlsFile")[0].files[0]);
				// 清除file
				let obj = document.getElementById('musicXlsFile');
				obj.value = '';

				$.ajax({
					type: "post",
					dataType: "json",
					processData: false,
					contentType: false,
					url: Vue.ctUrl + "songs/importSongs",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: formData,
					success: function(data) {
						if(data.response.result_code == "true") {
							layer.msg(data["response"]["error_msg"]);
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data["response"]["error_msg"]);
						}
					},
					error: function(err) {
						layer.msg("网络原因");
					}
				});
			},
			// 点击新增歌曲

			// 获取歌曲语言
			getQzgLanguage: function() {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "publicData/api_getSongLanguage",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							_this.languageDatas = data.response.data;
						} else {
							Vue.timeoutfun(data.response.result_status, _self);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 获取歌曲分类
			getQzgType: function() {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "publicData/api_getSongClass",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							_this.typeDatas = data.response.data;
						} else {
							Vue.timeoutfun(data.response.result_status, _self);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 点击上传封面
			addCoverFun: function(num) {
				if(num == '1') {
					this.$refs.coverFile1.click();
				} else if(num == '2') {
					this.$refs.coverFile2.click();
				}
			},
			// 上传封面
			uploadCover: function(e, num) {
				let _this = this;
				let layIndex = layer.load(2, {
					shade: [0.1, '#ececec']
				});
				let file = e.target.files[0];
				// 清除file
				if(num == '1') {
					let obj = document.getElementById('coverFile1');
					obj.value = '';
					obj.outerHTML = obj.outerHTML;
				} else if(num == '2') {
					let obj = document.getElementById('coverFile2');
					obj.value = '';
					obj.outerHTML = obj.outerHTML;
				}
				// 压缩图片
				var reader = new FileReader(),
					img = new Image();
				var canvas = document.createElement('canvas');
				var context = canvas.getContext('2d');
				console.log(file);
				if(typeof(file) == 'undefined') {
					layer.msg('图片上传失败');
					layer.close(layIndex);
					return false;
				}
				reader.readAsDataURL(file);
				reader.onload = function(e) {
					img.src = e.target.result;
				};
				img.onload = function () {
					// 图片原始尺寸
					var originWidth = this.width;
					var originHeight = this.height;
					// 最大尺寸限制
					var maxWidth = 320, maxHeight = 240;
					// 目标尺寸
					var targetWidth = originWidth, targetHeight = originHeight;
					// 图片尺寸超过限制
					if(originWidth > maxWidth || originHeight > maxHeight) {
						if(originWidth / originHeight > maxWidth / maxHeight) {
							// 更宽，按照宽度限定尺寸
							targetWidth = maxWidth;
							targetHeight = Math.round(maxWidth * (originHeight / originWidth));
						} else {
							targetHeight = maxHeight;
							targetWidth = Math.round(maxHeight * (originWidth / originHeight));
						}
					}
					// canvas对图片进行缩放
					canvas.width = targetWidth;
					canvas.height = targetHeight;
					// 清除画布
					context.clearRect(0, 0, targetWidth, targetHeight);
					// 图片压缩
					context.drawImage(img, 0, 0, targetWidth, targetHeight);
					// canvas转为blob并上传
					var dataurl = canvas.toDataURL('image/png');
					var blob = dataURLtoBlob(dataurl);
					// 创建forme
					var form = new FormData();
					form.append('img', blob, "image.png");
					form.append("upload_path", "ktv_test");
					// 上传
					$.ajax({
						type: "post",
						dataType: "json",
						processData: false,
						contentType: false,
						url: Vue.ctUrl + "Upload/api_uploadPic",
						crossDomain: true,
						xhrFields: {
							withCredentials: true
						},
						data: form,
						success: function(data) {
							if(data.response.result_code == "true") {
								if(num == '1') {
									_this.cover_url1 = data.response.resault.img_url;
									$('.qzg-dfimg1').attr('suc', '1');
								} else if(num == '2') {
									_this.cover_url2 = data.response.resault.img_url;
									$('.qzg-dfimg1').attr('suc', '1');
								}
							} else {
								Vue.timeoutfun(data.response.result_status, _this);
								layer.msg("图片上传失败");
							}
							layer.close(layIndex);
						},
						error: function(err) {
							layer.msg("网络原因");
							layer.close(layIndex);
						}
					});
				}
			},
			// 点击选择语言
			goSelLanguage: function() {
				this.showEdit = false;
				this.showlanguage = true;
			},
			// 清空语言
			clearLanguage: function() {
				this.language_txt = '';
				this.szLanguage = '';
			},
			// 确定语言
			lgSelFun: function() {
				let _this = this;
				_this.languageDatas.forEach(function(item) {
					if(item.id == _this.szLanguage) {
						_this.language_txt = item.name;
					}
				});
				_this.showEdit = true;
				_this.showlanguage = false;
			},
			// 返回
			lgBackEdit: function() {
				this.showEdit = true;
				this.showlanguage = false;
			},
			// 点击选择分类
			goSelType: function() {
				this.showEdit = false;
				this.showType = true;
			},
			// 清空分类
			clearType: function() {
				this.type_txt = '';
				this.szClass = '';
			},
			// 确定分类
			typeSelFun: function() {
				let _this = this;
				_this.typeDatas.forEach(function(item) {
					if(item.id == _this.szClass) {
						_this.type_txt = item.name;
					}
				});
				_this.showEdit = true;
				_this.showType = false;
			},
			// 返回
			typeBackEdit: function() {
				this.showEdit = true;
				this.showType = false;
			},
			// 新增/修改歌曲
			qzgSub: function(modify) {
				let _this = this;
				let cover_img1 = '',
					cover_img2 = '';

				if($('.qzg-dfimg1').attr('suc') == '1') {
					cover_img1 = _this.cover_url1;
				}
				if($('.qzg-dfimg2').attr('suc') == '1') {
					cover_img2 = _this.cover_url2;
				}

				let url = Vue.ctUrl + "songs/addMerchantSongs";
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"szSong_code": _this.szSong_code, // 歌曲编号
							"szSong_name": _this.szSong_name, // 歌曲名称
							"file_name": _this.file_name, // 歌曲文件名
							"nNameLen": _this.nNameLen, // 歌名长度
							"szPlayer": _this.szPlayer, // 歌手
							"szPlayer1": _this.szPlayer1, // 歌手1
							"szPlayer2": _this.szPlayer2, // 歌手2
							"songs_version": $(_this.$refs.songs_version).val(), // 歌曲版本
							"nPingFen": $(_this.$refs.nPingFen).val(), // 评分
							"frame_quality": $(_this.$refs.frame_quality).val(), // 画质
							"acc_quality": $(_this.$refs.acc_quality).val(), // 伴奏音质
							"songs_length": _this.songs_length, // 歌曲时长
							"prelude_length": _this.prelude_length, // 前奏时长
							"szNamePy1": _this.szNamePy1, // 首拼码1
							"szNamePy2": _this.szNamePy2, // 首拼码2
							"szNameAllPy1": _this.szNameAllPy1, // 全拼码1
							"szNameAllPy2": _this.szNameAllPy2, // 全拼码2
							"szUnicode": _this.szUnicode, // unicode编码
							"szJapanesePy": _this.szJapanesePy, // 日语检索码
							"cover_img1": cover_img1, // 封面视频戳1
							"cover_img2": cover_img2, // 封面视频戳2
							"szLanguage": _this.language_txt, // 语言
							"szClass": _this.type_txt, // 分类
						}
					},
					"comment": ""
				};
				if(modify == '2') {
					url = Vue.ctUrl + "songs/upMerchantSongs";
					datas["request"]["param"]["id"] = _this.theDet.id;
				}
				let datas2 = JSON.stringify(datas);
				console.log(datas2);
				$.ajax({
					type: "post",
					dataType: "json",
					url: url,
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							layer.msg(data.response.error_msg);
							$(_this.$refs.qzgList).bootstrapTable("destroy");
							_this.innitTable();
							_this.showList = true;
							_this.showEdit = false;
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 详情
			getQzgDet: function(id) {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": id
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "songs/getMerchantSongs",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							_this.theDet = data.response.result;
							_this.szSong_code = _this.theDet.szSong_code;
							_this.szSong_name = _this.theDet.szSong_name;
							_this.file_name = _this.theDet.file_name;
							_this.nNameLen = _this.theDet.nNameLen;
							_this.szPlayer = _this.theDet.szPlayer;
							_this.szPlayer1 = _this.theDet.szPlayer1;
							_this.szPlayer2 = _this.theDet.szPlayer2;
							$(_this.$refs.songs_version).val(_this.theDet.songs_version).trigger('change');
							$(_this.$refs.nPingFen).val(_this.theDet.nPingFen).trigger('change');
							$(_this.$refs.frame_quality).val(_this.theDet.frame_quality).trigger('change');
							$(_this.$refs.acc_quality).val(_this.theDet.acc_quality).trigger('change');
							_this.songs_length = _this.theDet.songs_length;
							_this.prelude_length = _this.theDet.prelude_length;
							_this.szNamePy1 = _this.theDet.szNamePy1;
							_this.szNamePy2 = _this.theDet.szNamePy2;
							_this.szNameAllPy1 = _this.theDet.szNameAllPy1;
							_this.szNameAllPy2 = _this.theDet.szNameAllPy2;
							_this.szUnicode = _this.theDet.szUnicode;
							_this.szJapanesePy = _this.theDet.szJapanesePy;
							if(_this.theDet.cover_img1 != '') {
								_this.cover_url1 = _this.theDet.cover_img1;
								$('qzg-dfimg1').attr('suc', '1');
							} else {
								_this.cover_url1 = require('../../assets/images/upload_qzg.png');
								$('qzg-dfimg1').removeAttr('suc');
							}
							if(_this.theDet.cover_img2 != '') {
								_this.cover_url2 = _this.theDet.cover_img2;
								$('qzg-dfimg2').attr('suc', '1');
							} else {
								_this.cover_url2 = require('../../assets/images/upload_qzg.png');
								$('qzg-dfimg2').removeAttr('suc');
							}
							_this.getQzgLanguage();
							_this.language_txt = _this.theDet.szLanguage;
							_this.languageDatas.forEach(function(item) {
								if(item.name == _this.language_txt) {
									_this.szLanguage = item.id;
								}
							});
							_this.getQzgType();
							_this.type_txt = _this.theDet.szClass;
							_this.languageDatas.forEach(function(item) {
								if(item.name == _this.type_txt) {
									_this.szClass = item.id;
								}
							});

							if(_this.modify == 2) {
								$('.qzg-edit input').prop('disabled', false);
								$('.qzg-edit select').prop('disabled', false);
								$('.qzg-edit img').prop('disabled', false);
							} else if(_this.modify == 3) {
								$('.qzg-edit input').prop('disabled', true);
								$('.qzg-edit select').prop('disabled', true);
								$('.qzg-edit img').prop('disabled', true);
							}
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 删除歌曲
			delQzg: function(id) {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": id
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "songs/delMerchantSongs",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							layer.msg(data.response.error_msg);
							$(_this.$refs.qzgList).bootstrapTable("destroy");
							_this.innitTable();
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},

		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	.qzg {
		.qzg-list {
			.title {
				margin: 0 0 30px;
			}
			.pdmg {
				margin: 0px 0 0 -17px;
			}
			.table-responsive {
				width: 100%;
				padding: 20px 0;
			}
			.text-orange {
				color: #009af0;
				cursor: pointer;
			}
		}
		.qzg-import {
			div {
				h1 {
					float: left;
					margin: 0;
					font-size: 30px;
				}
				input {
					display: none;
				}
				a {
					margin: 0 20px;
				}
			}
			p {
				margin: 20px 0 30px;
				color: #FF0707;
			}
			table {
				width: 100%;
				border-collapse: collapse;
				thead {
					background: #F5F5F5;
				}
				th, td {
					width: 9%;
					height: 36px;
					border: 1px solid #ddd;
					line-height: 36px;
					text-align: center;
				}
			}
		}
		.qzg-edit {
			.rowpadding {
				padding: 0;
				margin-bottom: 36px;
			}
			.edit-base {
				padding: 20px 0 20px 20px;
				margin: 20px 0;
				background: #f5f5f5;
				h4 {
					margin: 0 0 20px;
				}
			}
			.edit-other {
				padding: 20px 0 20px 20px;
				background: #f5f5f5;
				h4 {
					margin: 0 0 20px;
				}
				.qzg-dfimg1, .qzg-dfimg2 {
					width: 320px;
					height: 240px;
					border: none;
					cursor: pointer;
				}
				.qzg-uploadinp {
					display: none;
				}
				.visi_hid {
					width: 0;
					opacity: 0;
				}
			}
			.edit-btn {
				margin: 30px 0 0;
				button {
					margin: 0 40px 0 0;
				}
			}
		}
		.qzg-language, .qzg-type {
			ul {
				padding: 0 0 0 50px;
			}
			li {
				float: left;
				width: 20%;
				margin: 0 0 30px;
				span {
					margin: 0 0 0 5px;
				}
			}
		}
	}
</style>